import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const marketingDigitalPymesTableOfContents: TableOfContentsItem[] = [
  { id: "importancia", title: "¿Por qué es importante el marketing digital?", subItems: [
    { id: "sitio-web", title: "Crear un sitio web optimizado" },
    { id: "seo", title: "Optimización SEO" },
    { id: "redes-sociales", title: "Marketing en redes sociales" },
    { id: "email-marketing", title: "Email marketing" },
    { id: "publicidad-online", title: "Publicidad online" },
    { id: "marketing-contenido", title: "Marketing de contenido" },
    { id: "analisis", title: "Análisis y ajustes" },
    { id: "google-my-business", title: "Google My Business" },
  ]},
  { id: "estrategias", title: "Estrategias de marketing digital para PYMEs" },
  { id: "medir-exito", title: "Cómo medir el éxito" },
  { id: "conclusion", title: "Conclusión" },
  { id: "faq", title: "Preguntas frecuentes (FAQ)" },
];
